module.exports = __webpack_public_path__ + "img/xwzx.3a25c8dc.png";